import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=0b20b59c&scoped=true&"
import script from "./confirmModal.vue?vue&type=script&lang=js&"
export * from "./confirmModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=0b20b59c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b20b59c",
  null
  
)

export default component.exports